module.exports = "<app-header>\r\n\r\n</app-header>\r\n\r\n<div class=\"container-fluid\">\r\n\r\n\r\n        <router-outlet></router-outlet>\r\n\r\n  <app-footer></app-footer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main